import { render } from "./CreateService.vue?vue&type=template&id=0f5232bb&scoped=true"
import script from "./CreateService.vue?vue&type=script&lang=js"
export * from "./CreateService.vue?vue&type=script&lang=js"

import "./CreateService.vue?vue&type=style&index=0&id=0f5232bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5232bb"]])

export default __exports__